import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgQr = function SvgQr(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 25 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7 8H1a1 1 0 01-1-1V1a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1zM2.25 2a.25.25 0 00-.25.25v3.5c0 .138.112.25.25.25h3.5A.25.25 0 006 5.75v-3.5A.25.25 0 005.75 2h-3.5zM1 16h6a1 1 0 011 1v6a1 1 0 01-1 1H1a1 1 0 01-1-1v-6a1 1 0 011-1zm4.75 6a.25.25 0 00.25-.25v-3.5a.25.25 0 00-.25-.25h-3.5a.25.25 0 00-.25.25v3.5c0 .138.112.25.25.25h3.5zM17 0h6a1 1 0 011 1v6a1 1 0 01-1 1h-6a1 1 0 01-1-1V1a1 1 0 011-1zm4.75 6a.25.25 0 00.25-.25v-3.5a.25.25 0 00-.25-.25h-3.5a.25.25 0 00-.25.25v3.5c0 .138.112.25.25.25h3.5z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M4.84 11.114c0 .593.482 1.074 1.075 1.074h5.011c.593 0 1.074-.481 1.074-1.074V5.386a1.074 1.074 0 00-2.148 0v4.296c0 .198-.16.358-.358.358h-3.58c-.592 0-1.073.48-1.073 1.074zM15 22h-2.698a.333.333 0 01-.333-.333V19a1 1 0 00-2 0v4a1 1 0 001 1h4.03a1 1 0 100-2z"
  }), React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.5 20.25h-3a.75.75 0 01-.75-.75v-3a.75.75 0 01.75-.75h3a.75.75 0 01.75.75v3a.75.75 0 01-.75.75zm-2-3a.25.25 0 00-.25.25v1c0 .138.112.25.25.25h1a.25.25 0 00.25-.25v-1a.25.25 0 00-.25-.25h-1z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M24 11.063c0-.556-.45-1.006-1.006-1.006h-7.378c-.556 0-1.007.45-1.007 1.006v2.03a1.006 1.006 0 002.013 0v-.688c0-.186.15-.336.335-.336h6.037c.555 0 1.006-.45 1.006-1.006zM1.03 13.94a1.03 1.03 0 001.03-1.03v-1.823a1.03 1.03 0 10-2.06 0v1.823c0 .569.461 1.03 1.03 1.03zM18.002 22.97c0 .569.46 1.03 1.03 1.03h4.071a1.03 1.03 0 000-2.06h-4.072a1.03 1.03 0 00-1.03 1.03zM9.969 1.03c0 .569.46 1.03 1.03 1.03h1.823a1.03 1.03 0 100-2.06h-1.823a1.03 1.03 0 00-1.03 1.03zM22.958 15.75a1.042 1.042 0 100-2.083 1.042 1.042 0 000 2.083zM22.958 20.25a1.042 1.042 0 100-2.083 1.042 1.042 0 000 2.083zM4 14.982a1.042 1.042 0 100-2.084 1.042 1.042 0 000 2.084zM10.868 15.75a1.042 1.042 0 100-2.084 1.042 1.042 0 000 2.084z"
  }));
};

export default SvgQr;